// Change listener
CartItems.on("change", function() {
	$(".js-cart-items-count").text(CartItems.count());

	if (CartItems.count())
	{
		$(".js-show-cart-not-empty").show();
		$(".js-show-cart-empty").hide();	
	}
	else {
		$(".js-show-cart-not-empty").hide();	
		$(".js-show-cart-empty").show();	
	}

	if (CartItems.empty() || !CartItems.acceptTOS) {
		$(".js-btn-order").attr("disabled", true).prop("disabled", true);
	}
	else {
		$(".js-btn-order").removeAttr("disabled", true).removeProp("disabled", true);
	}
});

$("[name=has_invoice]").change(function(){
	if ($(this).is(':checked')) {
		$(".form-invoice").addClass("show");
	} else {
		$(".form-invoice").removeClass("show");
	}

}).change();
  
$(".js-toggle-tos").on("change", function() {
	if ($(this).is(":checked")) {
		CartItems.setAcceptTos(true);
		$("#order-button").removeAttr("disabled").removeProp("disabled");
	} else {
		CartItems.setAcceptTos(false);
		$("#order-button").attr("disabled", true).prop("disabled", true);
	}

});

$(".js-payment-method").on("change", function() {
	if ($(this).is(":checked")) {
		
		if ($(this).data("toggle") == "#cart-bank-transfer") {
		
			if ($("#cart-bank-transfer").hasClass('hidden')) {
				$("#cart-bank-transfer").removeClass('hidden');
			}
		} else {

			if (!$("#cart-bank-transfer").hasClass('hidden')) {
				$("#cart-bank-transfer").addClass('hidden');
			}
		}

		CartItems.paymentMethod = $(this).val();
	} else {
		if (!$("#cart-bank-transfer").hasClass('hidden')) {
			$("#cart-bank-transfer").addClass('hidden');
		}
	}

}).change();

$(".js-delivery-method").on("change", function() {
	var selectedOption = $(this).find('option:selected');

	var price = selectedOption.data('delivery-price');
	var freeDeliveryPrice = selectedOption.data('free-shipping-threshold');

	if (price) {
		CartItems.setDelivery({'price': price, 'freeShippingThreshold': freeDeliveryPrice});
	}

}).change();

$(document).on('click', '.js-add-to-cart', function() {
	var tooltip = $(this).children('.cart-tooltip');
	tooltip.addClass('tooltip-visible');

	timer = setTimeout(function() {
        tooltip.removeClass("tooltip-visible");
    }, 2000);
});